import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { BodyLarge } from "../atoms/Bodies"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { getSupportCenterLink, SupportCenterLinks } from "../../../utils/SupportCenterLinks"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const HowToModule = () => {
  return (
    <RoundedRectangle backgroundColor="mint-alternate">
      <RRIconBar iconName="icn-find" iconBackgroundColor="white" />
      <BodyLarge color="black-80" font="publico-headline">
        {l`client.reimbursements.theRightInformation`}
      </BodyLarge>
      <Spacer height={1} />
      <ArrowLink
        to={getSupportCenterLink(SupportCenterLinks.WHAT_SHOULD_MY_ITEMIZED_STATEMENT_INCLUDE)}
      >{l`client.reimbursements.shouldInclude`}</ArrowLink>
    </RoundedRectangle>
  )
}

export { HowToModule }
